import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from "@/components/ui/use-toast";
import { useTranslation } from "react-i18next";
import { getCurrentLanguage } from '@/lib/urlUtils';

export interface StripeCheckoutProps {
  courseSlug: string;
  userId: string;
  customButtonText?: string;
}

export default function StripeCheckout({ 
  courseSlug, 
  userId, 
  customButtonText 
}: StripeCheckoutProps) {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const handleCheckout = async () => {
    try {
      setLoading(true);

      // Get current language for proper routing
      const currentLanguage = getCurrentLanguage();

      const { data, error } = await supabase.functions.invoke('create-checkout-session', {
        body: {
          course_slug: courseSlug,
          user_id: userId,
          language: currentLanguage
        }
      });
      
      if (error || !data?.url) {
        toast({
          title: "Checkout Error",
          description: error?.message || "Failed to initiate checkout",
          variant: "destructive",
        });
        return;
      }
      
      window.location.href = data.url;
    } catch (err) {
      console.error("Checkout error:", err);
      toast({
        title: "Checkout Error",
        description: "An unexpected error occurred",
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <button 
      onClick={handleCheckout} 
      disabled={loading} 
      className="w-full bg-primary text-primary-foreground px-8 py-3 rounded-lg font-medium hover:bg-primary/90 transition-colors disabled:opacity-70"
    >
      {loading ? t("processing") : (customButtonText || t("enrollment.enroll_now"))}
    </button>
  );
}
